<template>
    <ob1-popin-modal2
        :id="modalId"
        :aria-labelledby="modalId+'-details'"
    >
        <recovery-details-part
            v-if="onlineRecovery"
            :recovery-details="onlineRecovery"
        />
        <ob1-separateur v-if="onlineRecovery && storeRecovery" class="mt-1 mb-2" />
        <recovery-details-part
            v-if="storeRecovery"
            :recovery-details="storeRecovery"
        />
    </ob1-popin-modal2>
</template>

<script>
import RecoveryDetailsPart from "./RecoveryDetailsPart.vue";

export default {
    name: "MobileRecoveryDetailsModal",
    components: {RecoveryDetailsPart},
    props: {
        modalId: {
            type: String,
            required: true
        },
        onlineRecovery: {
            type: Object,
            default: undefined
        },
        storeRecovery: {
            type: Object,
            default: undefined
        }
    }
}
</script>
